var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-9"},[_c('div',{staticClass:"text-center"},[_c('loading-animation'),_c('br'),_vm._v(" Please wait while we check your session... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }